import { AxiosStatic } from 'axios';
import { Store } from 'redux';
import { RootState } from 'store';

import { B2C_SUB_SYSTEM_SHORT_CODE } from '..';

export function includeHeadersInterceptor(axios: AxiosStatic, store: Store<RootState>) {
  axios.interceptors.request.use((req) => {
    const state = store.getState();

    const countryId = state?.country?.selectedCountry?.id;

    if (countryId) {
      req.headers!['x-countryId'] = countryId;
    }

    req.headers!['x-app'] = B2C_SUB_SYSTEM_SHORT_CODE.toLowerCase();

    return req;
  },
  (err) => {
    return Promise.reject(err);
  });
};
